import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, ButtonBase, IconButton, Icon, } from '@material-ui/core';
import { MovieChatItem } from '.';
import Apis from '../../../network/Apis';
import AppData from '../../../model/AppData';
import TIMUtils from '../../../network/TIMUtils';
import MChatModal from '../../view/MChatModal';
import DeviceEventEmitter, { EventName } from '../../../control/event';
import { ListView, PullToRefresh } from 'antd-mobile';
import MSnackbar from '../../view/MSnackbar';
import DateUtils from '../../../control/dateutils';
const ICON_FACE = require("../../../images/icons/biaoqing.png");
const MSG_ON = require("../../../images/icons/ic_block_gift_off.png");
const MSG_OFF = require("../../../images/icons/ic_block_gift_on.png");


const SYS_TIPS = '系统提示：本直播努力营造积极健康的直播环境，对直播内容进行24小时巡查， 任何传播违法、违规、诈骗、低俗不良、血腥暴力封建迷信等信息的行为一经发 现，将对违规者账号予以封号处理。';


class MovieChat extends React.Component {


    constructor(props) {
        super(props);

        let { matchId, matchType, room_id } = this.props.match.params;
        let { data } = this.props;
        this.roomId = room_id;
        this.matchType = matchType;
        this.matchId = matchId;
        if (this.matchType == 0) {
            this.matchType = data.match_type;
        }
        if (this.matchId == 0) {
            this.matchId = data.match_id;
        }
        if (this.roomId == 0) {
            this.roomId = data.room_id;
        }
        if (data && data.groupId) {
            this.groupId = data.groupId;
        }

        this.state = {
            data: [],
            value: '',
            chatRoomId: this.groupId,
            open: false,
            isRefreshing: false,
            showBarrage: true,
        };
        this.ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });
        console.log('MovieChat', props.data);

        this.sendtime = 0;
    }


    componentDidMount() {
        DeviceEventEmitter.on(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
        try { this.getMatchGroup(); } catch (error) { }
    }

    componentWillUnmount() {
        this.setState = () => false;
        DeviceEventEmitter.off(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
        const { chatRoomId } = this.state;
        if (chatRoomId && chatRoomId.length > 0) {
            TIMUtils.quitGroup(chatRoomId);
        }
    }

    getGroupHistoryMessageList = async (chatRoomId) => {
        try {
            let result = await TIMUtils.getGroupHistoryMessageList(chatRoomId, 0, 15);
            console.log('getGroupHistoryMessageList', result);
            if (result) {
                for (let i = 0; i < result.data.messageList.length; i++) {
                    if (!result.data.messageList[i].isRevoked) {
                        this.state.data.push(result.data.messageList[i]);
                    }
                }
                this.setState({ data: this.state.data }, () => {
                    if (this.refs.listview) {
                        this.refs.listview.scrollTo(0, this.refs.listview.listviewRef.scrollProperties.contentLength);
                    }
                });
            }
        } catch (error) {

        }
    }

    onMessageReceived = (event) => {
        console.log('onMessageReceived====>', event);
        const { data } = this.state;
        if (event && event.data) {
            for (let i = 0; i < event.data.length; i++) {
                if (TIMUtils.isMessageText(event.data[i].type) && event.data[i].conversationType == 'Group') {
                    if (!event.data[i].isRevoked) {
                        data.push(event.data[i]);
                        if (this.state.showBarrage && event.data[i].payload && event.data[i].payload.text) {
                            DeviceEventEmitter.emit(EventName.EVENT_BARRAGE_MSG, event.data[i].payload.text);
                        }
                    }
                } else if (TIMUtils.isMessageImage(event.data[i].type)) {
                    if (!event.data[i].isRevoked) {
                        data.push(event.data[i]);
                        if (this.state.showBarrage && event.data[i].payload && event.data[i].payload.text) {
                            DeviceEventEmitter.emit(EventName.EVENT_BARRAGE_MSG, event.data[i].payload.text);
                        }
                    }
                }
                /*
                 else if (TIMUtils.isSysMessage(event.data[i].type)) {
                    if (!event.data[i].isRevoked && event.data[i].payload && event.data[i].payload.userDefinedField) {
                        let d = event.data[i].payload.userDefinedField;
                        let obj = JSON.parse(d);
                        data.push({ nick: obj.nickname, isSys: true, payload: { text: '系统广播: 欢迎用户[' + obj.nickname + ']进入聊天室' } });
                    }
                }*/
            }
        }
        this.setState({ data: data }, () => {
            if (this.refs.listview) {
                this.refs.listview.scrollTo(0, this.refs.listview.listviewRef.scrollProperties.contentLength);
            }
        });
    }

    getMatchGroup = async () => {
        const { chatRoomId } = this.state;
        console.log('getMatchGroup', chatRoomId);

        if (chatRoomId && chatRoomId != '') {
            let joinResult = await TIMUtils.joinGroup(chatRoomId);
            console.log('joinResult', joinResult);
            if (joinResult.code == 0) {
                this.getGroupHistoryMessageList(chatRoomId);
                this._enterChatRoom(chatRoomId);
            }
        } else {
            if (this.matchType && this.matchId) {
                let result = await Apis.encryptionMatchGroup(this.matchType, this.matchId);
                console.log('getMatchGroup', result);
                if (result.code == 200) {
                    this.setState({ chatRoomId: result.data });
                    let joinResult = await TIMUtils.joinGroup(result.data);
                    console.log('joinResult', joinResult);
                    if (joinResult.code == 0) {
                        this.getGroupHistoryMessageList(result.data);
                        this._enterChatRoom(result.data);
                    }
                }
            }
        }
    }


    _enterChatRoom = async (chatRoomId) => {
        let nickname = TIMUtils.nickName;
        if (!nickname || !chatRoomId) return;
        let result = await Apis.encryptionInGroup(nickname, chatRoomId);
        if (result.code == 200) {
            console.log('_enterChatRoom', result);
        }
    }


    _onClickMsg = () => {
        const { chatRoomId, value } = this.state;
        this._sendTextMessage(chatRoomId, value);
        this.setState({ value: '' });
    }

    _handleChange = (value) => {
        this.setState({ value: value });
    }

    _handleClose = () => {
        console.log('_handleClose');
        this.setState({ open: false });
    }

    _sendTextMessage(chatRoomId, message) {
        if (!AppData.me.isLogin()) {
            this.props.history.push('/login');
            return;
        }
        if (!chatRoomId || chatRoomId == '' || chatRoomId == '0') {
            return;
        }
        let nowTime = DateUtils.getCurTime();
        if (nowTime - this.sendtime < 10 * 1000) {
            this.refs.toast.show('聊天太过频繁，请稍后尝试~');
            return;
        }

        if (!message || message == '') {
            return;
        }

        message = AppData.keywordShield(message);

        let result = null;
        try {
            result = TIMUtils.sendTextMessage(chatRoomId, message);
        } catch (error) {

        }

        if (result) {
            result.then(res => {
                console.log('_sendTextMessage', chatRoomId, message, res);
                res.data.message.nick = TIMUtils.nickName;
                this.state.data.push(res.data.message);
                if (this.state.showBarrage && res.data.message.payload && res.data.message.payload.text) {
                    DeviceEventEmitter.emit(EventName.EVENT_BARRAGE_MSG, res.data.message.payload.text);
                }
                this.setState({ data: this.state.data }, () => {
                    if (this.refs.listview) {
                        this.refs.listview.scrollTo(0, this.refs.listview.listviewRef.scrollProperties.contentLength);
                    }
                });

                this.sendtime = DateUtils.getCurTime();
            });
        }
    }

    _onSendMsg = (dom) => {
        let message = '';
        for (let i = 0; i < dom.childNodes.length; i++) {
            let child = dom.childNodes[i];
            if (child.nodeName == 'IMG') {
                message += child.alt;
            } else if (child.nodeName == '#text') {
                message += child.nodeValue;
            }
        }
        const { chatRoomId } = this.state;
        this._sendTextMessage(chatRoomId, message);
        this.setState({ open: false });
    }

    _showChatPanel = () => {
        this.setState({ open: true });
    }

    _showBarrage = () => {
        let showBarrage = !this.state.showBarrage;
        this.setState({ showBarrage: showBarrage });
        console.log('showBarrage', showBarrage);
        DeviceEventEmitter.emit(EventName.EVENT_SHOW_BARRAGE, showBarrage);
    }

    _onClickMessage() {
        // if (!AppData.me.isLogin()) {
        //     this.props.history.push('/login');
        //     return;
        // }
        // let { user_id } = this.props.data;
        // if (!AppData.isStarAnchor(user_id)) {
        //     if (this.refs.toast) {
        //         this.refs.toast.show('关注主播才可以私信哦~');
        //         return;
        //     }
        // }
        console.log('_onClickMessage', this.props.data);
        let { data } = this.props;
        this.props.history.push({ pathname: '/privateletter/' + data.user_id + '/userProfile', data: data.nickname });
    }

    _onRefresh = () => {

    }

    _renderHeader = () => {
        if (AppData.ServerConfig && AppData.ServerConfig.chat_show_url && AppData.ServerConfig.chat_show_url.length > 0) {
            return (
                <Grid container direction='column' style={{ paddingLeft: 8, paddingRight: 8, marginTop: 8 }}>
                    <Typography style={{ color: '#878787', fontSize: 10, maxWidth: '100%' }}>
                        {SYS_TIPS + '防丢失请记住备用域名'} <a target="_blank" href={AppData.ServerConfig.chat_show_url}>{AppData.ServerConfig.chat_show_url}</a>{'或者下载APP'}
                    </Typography>
                </Grid>
            );
        }
        return (
            <Grid container direction='column' style={{ paddingLeft: 8, paddingRight: 8, marginTop: 8 }}>
                <Typography style={{ color: '#878787', fontSize: 10, maxWidth: '100%' }}>
                    {SYS_TIPS}
                </Typography>
            </Grid>
        );
    }

    _onEndReached = () => {

    }

    _renderFooter() {
        return (
            <Grid style={{ height: 88 * 2 }}>

            </Grid>
        );
    }

    _renderItem = (data, sectionID, rowID) => {
        return (
            <MovieChatItem key={rowID} data={data} />
        );
    }

    render() {
        const { classes } = this.props;
        const { data, value, open, isRefreshing, showBarrage } = this.state;
        return (
            <Grid container direction='column' alignItems='center' justify='center' className={classes.root}>
                <ListView
                    ref='listview'
                    initialListSize={data.length}
                    listPrefixCls='padding: 0px'
                    style={{ width: '100vw', height: 'calc(100vh - 56vw - 133px)', maxWidth: '100%', padding: 0, paddingTop: 8 }}
                    contentContainerStyle={{ width: '100%', padding: 0 }}
                    dataSource={this.ds.cloneWithRows(data)}
                    renderRow={this._renderItem}
                    pageSize={10}
                    useBodyScroll={false}
                    renderHeader={this._renderHeader}
                    onEndReached={this._onEndReached}
                    onEndReachedThreshold={10}
                    // pullToRefresh={
                    //     <PullToRefresh
                    //         refreshing={isRefreshing}
                    //         onRefresh={this._onRefresh}
                    //     />
                    // }

                    renderFooter={this._renderFooter}
                >
                </ListView>
                <Grid container direction='row' alignItems='center' justify='space-between' style={{ backgroundColor: '#FFF', height: 55, position: 'fixed', bottom: 0 }}>

                    <Grid container direction='row' alignItems='center' justify='space-between' className={classes.inputBack}>
                        <input value={value} onChange={(e) => this._handleChange(e.target.value)} className={classes.input} placeholder='您如何看待这场球...'></input>
                        <IconButton onClick={() => this._showChatPanel()} className={classes.iconButton}>
                            <img src={ICON_FACE} style={{ width: 20, height: 20 }}></img>
                        </IconButton>
                    </Grid>
                    <Grid container direction='row' justify='flex-end' style={{ maxWidth: 70 }}>
                        <ButtonBase onClick={() => this._onClickMsg()} className={classes.sendMsg}>发送</ButtonBase>
                    </Grid>
                </Grid>
                <MChatModal open={open} isFile={false} onClose={() => this._handleClose()} onSendMsg={(val) => this._onSendMsg(val)} />
                <MSnackbar ref='toast' />
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        backgroundColor: '#F5F5F5'
    },
    inputBack: {
        backgroundColor: '#EDEDED',
        borderRadius: 17.5,
        height: 35,
        flex: 1,
        marginLeft: 8,
        marginRight: 8,
    },
    input: {
        outline: 'none',
        border: 0,
        marginLeft: 16,
        backgroundColor: 'transparent',
        height: 35,
        flex: 1,
        fontSize: 12,
    },
    sendMsg: {
        backgroundColor: '#0D0D0D',
        color: '#FFF',
        fontSize: 14,
        height: 35,
        width: 70,
        borderRadius: 17.5,
        marginRight: 8,
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        width: 20,
        height: 20,
        marginRight: 8,
    },
}))(MovieChat));